import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const headingButtonFadeInDurationMs = 125;
const mobileNavigationTokens = combineTokens("--mobile-nav", {
  toolsWidth: units.px(0)
});
const navigationCls = "_61n1aqo9qh";
const headerCls = "_61h12ukyxf";
const burgerCls = "_61bldb48p";
const headingButtonWrapper = "_61h1gpppjn";
const headingButtonCls = "_61h1ki65xl";
const headingCls = "_61h1ukur6b";
const stateWrapperCls = "_61s1pjbmwy";
const throbberWrapperCls = "_61t1k98b2i";
const throbberCls = "_61t1f7ui8c";
const chevronCls = "_61c130t6cc";

/**
 * Backdrop to be displayed over main content when navigation list is open
 */
const backdropCls = "_61b1amv3jr";

export { backdropCls, burgerCls, chevronCls, headerCls, headingButtonCls, headingButtonFadeInDurationMs, headingButtonWrapper, headingCls, mobileNavigationTokens, navigationCls, stateWrapperCls, throbberCls, throbberWrapperCls };
import "./Navigation.style.linaria.module.css";
//# sourceMappingURL=Navigation.style.js.map
